/*
 * @Description:
 * @Author: wjx
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-29 13:49:26
 * @LastEditTime: 2021-02-04 18:40:09
 */
import Config from '@/config/index';
const AUTHKEY = Config.token;
export function getToken() {
  return localStorage.getItem(AUTHKEY);
}
export function setToken(tokenValue) {
  localStorage.setItem(AUTHKEY, tokenValue);
}
export function delToken() {
  localStorage.removeItem(AUTHKEY);
}
